import { render, staticRenderFns } from "./ListaSeguros.vue?vue&type=template&id=3f187095&"
import script from "./ListaSeguros.vue?vue&type=script&lang=js&"
export * from "./ListaSeguros.vue?vue&type=script&lang=js&"
import style0 from "./ListaSeguros.vue?vue&type=style&index=0&id=3f187095&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports